import { Alert, Button, Form, FormGroup, Modal, Row, Table } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { faSms, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Check2, DashCircle, ExclamationTriangle, Pencil, PlusSquareFill, Trash } from "react-bootstrap-icons";
import { Fragment, useEffect, useState } from "react";
import { addNewTempalte, editTempalte, getSMSTemplates, deleteSMSTemplate } from "../../BaseInfo/store/api/SMSApi";

const ModalSMSTemplates = () => {
    const [submitError, setSubmitError] = useState(null);
    const [currentTemplate, setCurrent] = useState({ TemplateType: "", SMSTitle: "", SMSBody: "", ID: 0 });
    const [templates, getTemplates] = useState([]);
    const history = useHistory();
    function close() {
        history.goBack();
    }
    function submitTemplate() {
        setSubmitError(null);
        if ((currentTemplate.TemplateType ?? "") === "" || (currentTemplate.SMSTitle ?? "") === "" || (currentTemplate.SMSBody ?? "") === "") {
            setSubmitError("اطلاعات وارد شده ناقص است");
            return;
        }
        const onSuccess = (data) => {
            if (data && data.Data && Array.isArray(data.Data)) {
                getTemplates(data.Data);
                cancelTemplate();
            }
        }
        if (currentTemplate.ID) {
            editTempalte(currentTemplate, onSuccess);
        }
        else {
            addNewTempalte(currentTemplate, onSuccess);
        }
    }
    function cancelTemplate() {
        setSubmitError(null);
        setCurrent({ TemplateType: "", SMSTitle: "", SMSBody: "" });
    }
    function prepareAdd() {
        setCurrent({ TemplateType: "", SMSTitle: "", SMSBody: "", ID: 0 });
    }
    function deleteTemplate() {
        const onSuccess = (data) => {
            if (Array.isArray(data?.Data ?? "")) {
                getTemplates(data.Data);
                cancelTemplate();
            }
        }
        deleteSMSTemplate(currentTemplate.ID, onSuccess);

    }
    useEffect(() => {
        const onSuccess = (data) => {
            if (Array.isArray(data?.Data ?? "")) {
                getTemplates(data.Data);
            }
        }
        getSMSTemplates("", onSuccess);
    }, [])
    return (
        <Modal size="lg" show={true} onHide={() => { }}>
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faSms} size="lg" />&nbsp;
                    مدیریت قالب های پیامک
                </span>
                <span><FontAwesomeIcon icon={faTimes} size="lg" onClick={close} /></span>
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                {Number(currentTemplate.ID) >= 0 &&
                    <div className="rowBorder" style={{ padding: "0 5px 5px 5px" }}>
                        <Row>
                            <FormGroup className="col-md-6">
                                <label>نوع قالب</label>
                                <select className="form-control" value={currentTemplate.TemplateType ?? ""} onChange={e => setCurrent({ ...currentTemplate, TemplateType: e.target.value })}>
                                    <option value="">انتخاب کنید</option>
                                    <option value="customers">مشتریان</option>
                                    <option value="services">سرویس ها</option>
                                </select>
                            </FormGroup>
                            <FormGroup className="col-md-6">
                                <label>عنوان قالب</label><label style={{ color: "red" }}>*</label>
                                <Form.Control value={currentTemplate.SMSTitle} onChange={e => setCurrent({ ...currentTemplate, SMSTitle: e.target.value })} />
                            </FormGroup>
                            <FormGroup className="col-md-6">
                                <label>الگوهای تعریف شده</label>
                                <select className="form-control" onChange={e => setCurrent({ ...currentTemplate, SMSBody: currentTemplate.SMSBody + e.target.value })}>
                                    <option value="">انتخاب کنید</option>
                                    <option value="[ADDR]">آدرس</option>
                                    <option value="[G.SD]">آغاز گارانتی</option>
                                    <option value="[G.C]">ابطال گارانتی</option>
                                    <option value="[PROVINCE]">استان</option>
                                    <option value="[G.ED]">پایان گارانتی</option>
                                    <option value="[S.D]">تاریخ ارسال</option>
                                    <option value="[C.D]">تاریخ پذیرش</option>
                                    <option value="[COUNT]">تعداد</option>
                                    <option value="[TEL]">تلفن</option>
                                    <option value="[DCR]">توضیحات</option>
                                    <option value="[S.T]">ساعت ارسال</option>
                                    <option value="[C.H]">ساعت پذیرش</option>
                                    <option value="[F.S]">سرویس رایگان</option>
                                    <option value="[P.S]">سریال کالا</option>
                                    <option value="[S.N]">شماره سرویس</option>
                                    <option value="[G.N]">شماره گارانتی</option>
                                    <option value="[MOBILE]">شماره همراه</option>
                                    <option value="[CITY]">شهر</option>
                                    <option value="[TITLE]">عنوان احترام</option>
                                    <option value="[GIFTCODE]">کد کارت جایزه</option>
                                    <option value="[P.H]">مارک کالا</option>
                                    <option value="[P.M]">مدل کالا</option>
                                    <option value="[ExtAttr1]">مشخصه یک</option>
                                    <option value="[ExtAttr2]">مشخصه دو</option>
                                    <option value="[ExtAttr3]">مشخصه سه</option>
                                    <option value="[ExtAttr4]">مشخصه چهار</option>
                                    <option value="[ExtAttr5]">مشتریان پنج</option>
                                    <option value="[ExtAttr6]">مشخصه شش</option>
                                    <option value="[ExtAttr7]">مشخصه هفت</option>
                                    <option value="[ExtAttr8]">مشخصه هشت</option>
                                    <option value="[ExtAttr9]">مشخصه نه</option>
                                    <option value="[ExtAttr10]">مشخصه ده</option>
                                    <option value="[NAME]">نام</option>
                                    <option value="[P.N]">نام کالا</option>
                                    <option value="[AGENTNAME]">نام نمایندگی</option>
                                    <option value="[SRV]">نوع سرویس</option>
                                    <option value="[S.S]">وضعیت سرویس</option>
                                    <option value="[EMAIL]">Email</option>
                                </select>
                            </FormGroup>
                        </Row>

                        <FormGroup>
                            <label>متن قالب</label><label style={{ color: "red" }}>*</label>
                            <Form.Control as="textarea" value={currentTemplate.SMSBody} onChange={e => setCurrent({ ...currentTemplate, SMSBody: e.target.value })} />
                        </FormGroup>
                        {submitError &&
                            <Alert className="mt-1" variant="danger"><ExclamationTriangle size={18} />&nbsp; {submitError}</Alert>}
                        <Button variant="success" className="group-Btn mt-2" onClick={submitTemplate}>
                            {Number(currentTemplate.ID) > 0 &&
                                <Fragment>
                                    <Pencil size={15} />&nbsp;ویرایش قالب
                                </Fragment>
                            }
                            {!(Number(currentTemplate.ID) > 0) &&
                                <Fragment>
                                    <Check2 size={15} />&nbsp;ثبت قالب
                                </Fragment>}
                        </Button>
                        <Button variant="danger" className="group-Btn mt-2" onClick={cancelTemplate}><DashCircle size={15} />&nbsp;انصراف</Button>
                        {Number(currentTemplate.ID) > 0 &&
                            <Button variant="outline-danger" className="group-Btn mt-2" onClick={deleteTemplate} style={{ float: "left" }}><Trash size={15} />&nbsp;حذف قالب</Button>
                        }
                    </div>
                }
                {!(Number(currentTemplate.ID) >= 0) &&
                    <PlusSquareFill color="#5339ca" size={23} className="hoverIcon" style={{ cursor: "pointer" }} onClick={prepareAdd} />
                }
                <Table className="fixedTable scrolledTable" responsive>
                    <thead>
                        <tr>
                            <th style={{ width: "7%" }}>ردیف</th>
                            <th style={{ width: "15%" }}>نوع قالب</th>
                            <th style={{ width: "20%" }}>عنوان قالب</th>
                            <th style={{ width: "58%" }}>متن قالب</th>
                        </tr>
                    </thead>
                    <tbody>
                        {templates && Array.isArray(templates) &&
                            templates.map((tmp, i) =>
                                <tr key={i} className="resultTableRow" onClick={() => setCurrent(tmp)}>
                                    <td style={{ width: "7%" }}>{i + 1}</td>
                                    <td style={{ width: "15%" }}>{tmp.PTemplateType ?? "ـــ"}</td>
                                    <td style={{ width: "20%" }}>{tmp.SMSTitle}</td>
                                    <td style={{ width: "58%" }}>{tmp.SMSBody}</td>
                                </tr>)
                        }
                    </tbody>
                </Table>
            </Modal.Body>
        </Modal>
    )
}
export default ModalSMSTemplates;